import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_instance13way2il9a8jt as Companion_instance,
  Enum3alwj03lh1n41 as Enum,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { SerializerFactory1qv9hivitncuv as SerializerFactory } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _get_$cachedSerializer__te6jhj($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function Aggregate$Companion$_anonymous__cowofk() {
  return createSimpleEnumSerializer('com.lightningkite.services.database.Aggregate', values());
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  Aggregate_Sum_instance = new (Aggregate())('Sum', 0);
  Aggregate_Average_instance = new (Aggregate())('Average', 1);
  Aggregate_StandardDeviationSample_instance = new (Aggregate())('StandardDeviationSample', 2);
  Aggregate_StandardDeviationPopulation_instance = new (Aggregate())('StandardDeviationPopulation', 3);
  if (Companion_instance_0 === VOID) {
    Companion_instance;
    new (Companion())();
  }
}
var Aggregate_Sum_instance;
var Aggregate_Average_instance;
var Aggregate_StandardDeviationSample_instance;
var Aggregate_StandardDeviationPopulation_instance;
function values() {
  static_init();
  return [Aggregate_Sum_getInstance(), Aggregate_Average_getInstance(), Aggregate_StandardDeviationSample_getInstance(), Aggregate_StandardDeviationPopulation_getInstance()];
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, Aggregate$Companion$_anonymous__cowofk);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  static_init();
  return Companion_instance_0;
}
var AggregateClass;
function Aggregate() {
  if (AggregateClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'Aggregate', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    AggregateClass = $;
  }
  return AggregateClass;
}
function Aggregate_Sum_getInstance() {
  static_init();
  return Aggregate_Sum_instance;
}
function Aggregate_Average_getInstance() {
  static_init();
  return Aggregate_Average_instance;
}
function Aggregate_StandardDeviationSample_getInstance() {
  static_init();
  return Aggregate_StandardDeviationSample_instance;
}
function Aggregate_StandardDeviationPopulation_getInstance() {
  static_init();
  return Aggregate_StandardDeviationPopulation_instance;
}
//region block: exports
export {
  Aggregate_Average_getInstance as Aggregate_Average_getInstance1jkg6g5zxf9jw,
  Aggregate_Sum_getInstance as Aggregate_Sum_getInstance1dnbxkj64thbo,
  Companion_getInstance as Companion_getInstance3e2h11tnt9mtt,
};
//endregion

//# sourceMappingURL=Aggregate.mjs.map
